export const ACCOUNT_TYPE  = Object.freeze({
    PERSONAL: "PERSONAL",
    BUSINESS: "BUSINESS",
    NON_PROFIT_ORGANIZATION: "NON_PROFIT_ORGANIZATION",
});